(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("cHoQ1", function(module, exports) {

var $kWqGi = parcelRequire("kWqGi");
document.querySelectorAll(".s-price-list").forEach((section)=>{
    const radios = section.querySelectorAll(".s-price-list__radio input");
    const groups = section.querySelectorAll(".g-price-lists__cell");
    radios.forEach((radio)=>{
        radio.addEventListener("change", ()=>{
            const selectedValue = section.querySelector(".s-price-list__radio input:checked")?.value;
            if (selectedValue === "all") {
                groups.forEach((group)=>{
                    group.classList.remove("d-none");
                });
                return;
            }
            groups.forEach((group)=>{
                group.classList.add("d-none");
                const activeGroupSelector = `.g-price-lists__cell[data-category="${selectedValue}"]`;
                if (!(0, $kWqGi.validateQuery)(activeGroupSelector)) return;
                const activeGroup = section.querySelector(activeGroupSelector);
                activeGroup?.classList.remove("d-none");
            });
        });
    });
});

});
parcelRegister("kWqGi", function(module, exports) {

$parcel$export(module.exports, "validateQuery", function () { return $f3edebc483f39217$export$6d4016d301bc6e21; });
function $f3edebc483f39217$export$6d4016d301bc6e21(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (e) {
    // something here to check WHY it's invalid
    }
    return false;
}

});


})();
//# sourceMappingURL=price-list-section.5bbabf86.js.map
